/* Simply Meats — theme JS (Dawn add-on) */
(function () {
  'use strict';

  /* Every SM section includes this file's script tag, and the browser executes
     each copy — so on a page with 8 SM sections everything here would run 8
     times. Toggles bound 8x cancel out (dead burger) and quick-add would fire
     8x. Run once per page, no matter how many tags load it. */
  if (window.__smThemeInit) return;
  window.__smThemeInit = true;

  /* ---------- Simply Meats cart drawer (replaces Dawn's) ---------- */
  var SM_CART_SECTIONS = ['sm-cart-drawer'];

  function smDrawerRoot() { return document.querySelector('[data-sm-cdrawer]'); }

  function smDrawerRender(sections) {
    if (!sections || !sections['sm-cart-drawer']) return;
    var root = smDrawerRoot();
    var doc = new DOMParser().parseFromString(sections['sm-cart-drawer'], 'text/html');
    var freshRoot = doc.querySelector('[data-sm-cdrawer]');
    if (!root || !freshRoot) return;
    var fresh = freshRoot.querySelector('[data-sm-cdrawer-inner]');
    var live = root.querySelector('[data-sm-cdrawer-inner]');
    if (fresh && live) live.innerHTML = fresh.innerHTML;
    if (window.__smShipbarAnimate) window.__smShipbarAnimate(root);
    /* never replace the header button's markup — only refresh the badge count */
    var count = freshRoot.getAttribute('data-item-count');
    if (count !== null) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        var badge = bubble.querySelector('.sm-cart-count');
        if (badge) badge.textContent = count;
        var sr = bubble.querySelector('.visually-hidden');
        if (sr) sr.textContent = count + ' items in cart';
      }
    }
  }

  function smDrawerOpen() {
    var root = smDrawerRoot();
    if (!root) return;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sm-lock');
    var x = root.querySelector('.sm-cdrawer__x');
    if (x) x.focus({ preventScroll: true });
  }

  function smDrawerClose() {
    var root = smDrawerRoot();
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sm-lock');
  }

  async function smCartRequest(url, payload, busyEl) {
    if (busyEl) busyEl.classList.add('is-busy');
    try {
      payload.sections = SM_CART_SECTIONS;
      payload.sections_url = window.location.pathname;
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      if (data.status && data.status !== 200) throw new Error(data.description || data.message || 'Cart request failed');
      smDrawerRender(data.sections);
      return data;
    } finally {
      if (busyEl) busyEl.classList.remove('is-busy');
    }
  }

  async function smAddToCart(items, btn) {
    try {
      await smCartRequest((window.routes && window.routes.cart_add_url) || '/cart/add', { items: items });
      if (btn) {
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1300);
      }
      if (smDrawerRoot()) smDrawerOpen();
      else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    } catch (e) {
      console.error('[Simply Meats] add to cart:', e);
      if (btn) window.location.href = btn.dataset.productUrl || (window.routes && window.routes.cart_url) || '/cart';
    }
  }

  function smCartChange(key, quantity, lineEl) {
    smCartRequest((window.routes && window.routes.cart_change_url) || '/cart/change', { id: key, quantity: quantity }, lineEl)
      .catch(function (e) {
        console.error('[Simply Meats] cart change:', e);
        if (lineEl) lineEl.classList.remove('is-busy');
      });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.sm-add');
    if (!btn) return;
    e.preventDefault();
    const qty = parseInt(btn.dataset.qty || '1', 10);
    smAddToCart([{ id: parseInt(btn.dataset.variantId, 10), quantity: qty }], btn);
  });

  /* drawer interactions: open from header cart button, close, line qty/remove */
  document.addEventListener('click', function (e) {
    if (e.target.closest('#cart-icon-bubble') && smDrawerRoot()) {
      e.preventDefault();
      smDrawerOpen();
      return;
    }
    var closer = e.target.closest('[data-sm-cdrawer-close]');
    if (closer) {
      /* real links (e.g. empty-cart "Shop all cases") must still navigate */
      if (closer.tagName !== 'A') e.preventDefault();
      smDrawerClose();
      return;
    }
    /* any click outside the panel while the drawer is open closes it —
       works even if the scrim layer is missing or unstyled */
    var openRoot = smDrawerRoot();
    if (openRoot && openRoot.classList.contains('is-open')
        && e.target.closest('[data-sm-cdrawer]') && !e.target.closest('.sm-cdrawer__panel')) {
      e.preventDefault();
      smDrawerClose();
      return;
    }
    var line = e.target.closest('[data-sm-line]');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    var input = line.querySelector('[data-sm-line-qty]');
    var qty = parseInt((input && input.value) || '1', 10) || 1;
    if (e.target.closest('[data-sm-line-plus]')) smCartChange(key, Math.min(20, qty + 1), line);
    else if (e.target.closest('[data-sm-line-minus]')) smCartChange(key, Math.max(1, qty - 1), line);
    else if (e.target.closest('[data-sm-line-remove]')) smCartChange(key, 0, line);
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-sm-line-qty]');
    if (!input) return;
    var line = input.closest('[data-sm-line]');
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 1) qty = 1;
    smCartChange(line.getAttribute('data-line-key'), Math.min(20, qty), line);
  });

  window.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var root = smDrawerRoot();
      if (root && root.classList.contains('is-open')) smDrawerClose();
    }
  });

  /* product forms (PDP buy box, sticky bar): add via the drawer, never navigate to /cart */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    var id = parseInt(fd.get('id'), 10);
    if (!id) return;
    var item = { id: id, quantity: parseInt(fd.get('quantity') || '1', 10) || 1 };
    var plan = fd.get('selling_plan');
    if (plan) item.selling_plan = plan;
    var props = {};
    var hasProps = false;
    fd.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && value !== '') { props[m[1]] = value; hasProps = true; }
    });
    if (hasProps) item.properties = props;
    var btn = form.querySelector('[data-sm-cta]') || form.querySelector('[type="submit"]');
    smAddToCart([item], btn);
  });

  /* ---------- qty steppers (drawer lines manage their own) ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.sm-qty button');
    if (!b) return;
    if (b.closest('[data-sm-cdrawer]')) return;
    const input = b.parentElement.querySelector('input');
    const v = parseInt(input.value, 10) || 1;
    input.value = b.classList.contains('sm-qty__plus') ? Math.min(20, v + 1) : Math.max(1, v - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- weekly deal countdown (to end of chosen weekday) ---------- */
  document.querySelectorAll('[data-sm-countdown]').forEach((el) => {
    const endDay = parseInt(el.dataset.smCountdown, 10); // 0=Sun..6=Sat
    const d = el.querySelector('[data-cd-d]'), h = el.querySelector('[data-cd-h]'),
          m = el.querySelector('[data-cd-m]'), s = el.querySelector('[data-cd-s]');
    const pad = (x) => String(x).padStart(2, '0');
    function nextEnd() {
      const n = new Date(), e2 = new Date(n);
      e2.setDate(n.getDate() + ((endDay - n.getDay() + 7) % 7));
      e2.setHours(23, 59, 59, 999);
      if (e2 <= n) e2.setDate(e2.getDate() + 7);
      return e2;
    }
    let end = nextEnd();
    function tick() {
      let ms = end - new Date();
      if (ms < 0) { end = nextEnd(); ms = end - new Date(); }
      const t = Math.floor(ms / 1000);
      if (d) d.textContent = Math.floor(t / 86400);
      if (h) h.textContent = pad(Math.floor((t % 86400) / 3600));
      if (m) m.textContent = pad(Math.floor((t % 3600) / 60));
      if (s) s.textContent = pad(t % 60);
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---------- collection toolbar: sort + auto-submit filters ---------- */
  document.querySelectorAll('[data-sm-sort]').forEach((sel) => {
    sel.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    });
  });

  /* ---------- PDP gallery ---------- */
  document.querySelectorAll('[data-sm-gallery]').forEach((g) => {
    const slides = g.querySelectorAll('.sm-gslide');
    const thumbs = g.querySelectorAll('.sm-thumb');
    thumbs.forEach((t, i) => t.addEventListener('click', () => {
      slides.forEach((sl, x) => sl.classList.toggle('is-on', x === i));
      thumbs.forEach((th, x) => th.classList.toggle('is-on', x === i));
    }));
  });

  /* ---------- PDP purchase mode (one-time vs selling plan) ---------- */
  document.querySelectorAll('[data-sm-buybox]').forEach((box) => {
    const form = box.querySelector('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
    const planInput = box.querySelector('[name="selling_plan"]');
    const freqWrap = box.querySelector('.sm-freq');
    const freqSel = box.querySelector('[data-sm-freq]');
    const qtyInput = box.querySelector('[name="quantity"]');
    const modes = box.querySelectorAll('.sm-mode');
    const priceEl = box.querySelector('[data-sm-price]');
    const perEl = box.querySelector('[data-sm-per]');
    const saveEl = box.querySelector('[data-sm-save]');
    const ctaLabel = box.querySelector('[data-sm-cta-label]');
    const ctaPrice = box.querySelector('[data-sm-cta-price]');
    const barPrice = document.querySelector('[data-sm-bar-price]');
    const barInfo = document.querySelector('[data-sm-bar-info]');
    let data = {};
    try { data = JSON.parse(box.querySelector('[data-sm-plan-data]').textContent); } catch (e) { return; }

    const money = (cents) => (data.money_prefix || '$') + (cents / 100).toFixed(2);

    function current() {
      const on = box.querySelector('.sm-mode.is-on');
      const isSub = on && on.dataset.mode === 'sub';
      const planId = isSub && freqSel ? freqSel.value : '';
      let price = data.price;
      if (isSub && data.allocations && data.allocations[planId] != null) price = data.allocations[planId];
      return { isSub: isSub, planId: planId, price: price };
    }

    function update() {
      const c = current();
      const qty = parseInt((qtyInput && qtyInput.value) || '1', 10);
      if (planInput) planInput.value = c.planId;
      if (freqWrap) freqWrap.classList.toggle('is-show', c.isSub);
      if (priceEl) priceEl.textContent = money(c.price);
      if (perEl && data.weight_lb > 0) perEl.textContent = money(c.price / data.weight_lb) + '/lb';
      if (saveEl && data.shelf_per_lb > 0 && data.weight_lb > 0) {
        const shelfTotal = data.shelf_per_lb * data.weight_lb; /* cents */
        const save = shelfTotal - c.price;
        if (save > 0) {
          const pct = Math.round((save / shelfTotal) * 100);
          saveEl.textContent = 'You save ' + money(save) + ' (' + pct + '%) vs shelf price' + (c.isSub ? ' — on every delivery' : '');
        } else { saveEl.textContent = ''; }
      }
      if (ctaLabel) ctaLabel.textContent = c.isSub ? (data.t_subscribe || 'Start my subscription') : (data.t_add || 'Add to cart');
      if (ctaPrice) ctaPrice.textContent = '• ' + money(c.price * qty);
      if (barPrice) barPrice.textContent = money(c.price * qty);
      if (barInfo) barInfo.textContent = c.isSub ? (data.t_sub_short || 'Subscription') : (data.t_one_short || 'One-time');
    }

    modes.forEach((m) => m.addEventListener('click', () => {
      modes.forEach((x) => {
        const on = x === m;
        x.classList.toggle('is-on', on);
        const input = x.querySelector('input');
        if (input) input.checked = on;
      });
      update();
    }));
    if (freqSel) freqSel.addEventListener('change', update);
    if (qtyInput) qtyInput.addEventListener('change', update);
    update();

    /* sticky buy bar */
    const bar = document.querySelector('.sm-buybar');
    const cta = box.querySelector('[data-sm-cta]');
    if (bar && cta && 'IntersectionObserver' in window) {
      new IntersectionObserver((es) => {
        es.forEach((en) => bar.classList.toggle('is-show', !en.isIntersecting && en.boundingClientRect.top < 0));
      }, { threshold: 0 }).observe(cta);
      const barBtn = bar.querySelector('[data-sm-bar-add]');
      if (barBtn && form) barBtn.addEventListener('click', () => {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  });

  /* ---------- gift card PDP: denomination pills + recipient form ---------- */
  document.querySelectorAll('[data-sm-giftbox]').forEach(function (box) {
    var idInput = box.querySelector('form [name="id"]');
    var pills = box.querySelectorAll('[data-sm-denom]');
    var priceEl = box.querySelector('[data-sm-gprice]');
    var ctaPrice = box.querySelector('[data-sm-gcta-price]');
    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        pills.forEach(function (x) {
          var on = x === p;
          x.classList.toggle('is-on', on);
          x.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        if (idInput) idInput.value = p.dataset.variantId;
        if (priceEl) priceEl.textContent = p.dataset.price;
        if (ctaPrice) ctaPrice.textContent = '• ' + p.dataset.price;
      });
    });

    var toggle = box.querySelector('[data-sm-gift-toggle]');
    var fields = box.querySelector('[data-sm-gift-fields]');
    if (toggle && fields) {
      var syncGift = function () {
        fields.classList.toggle('is-open', toggle.checked);
        fields.querySelectorAll('input,textarea').forEach(function (i) { i.disabled = !toggle.checked; });
      };
      toggle.addEventListener('change', syncGift);
      syncGift();
    }

    var msg = box.querySelector('[data-sm-gift-msg]');
    var count = box.querySelector('[data-sm-gift-count]');
    if (msg && count) {
      var updCount = function () { count.textContent = (msg.maxLength - msg.value.length) + ' characters left'; };
      msg.addEventListener('input', updCount);
      updCount();
    }

    var dateIn = box.querySelector('[data-sm-gift-date]');
    if (dateIn) {
      var pad2 = function (n) { return String(n).padStart(2, '0'); };
      var iso = function (d) { return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate()); };
      var now = new Date();
      dateIn.min = iso(now);
      dateIn.max = iso(new Date(now.getTime() + 89 * 86400000)); /* Shopify allows up to 90 days out */
    }

    var offset = box.querySelector('[name="properties[__shopify_offset]"]');
    if (offset) offset.value = new Date().getTimezoneOffset().toString();
  });

  /* ---------- FBT combo ---------- */
  document.querySelectorAll('[data-sm-fbt]').forEach((wrap) => {
    const items = wrap.querySelectorAll('.sm-citem[data-variant-id]');
    const totalEl = wrap.querySelector('[data-fbt-total]');
    const subEl = wrap.querySelector('[data-fbt-sub]');
    const addBtn = wrap.querySelector('[data-fbt-add]');
    function update() {
      let total = 0, count = 0, lb = 0;
      items.forEach((it) => {
        if (it.classList.contains('is-off')) return;
        total += parseInt(it.dataset.price, 10);
        count += 1;
        lb += parseFloat(it.dataset.weight || '0');
      });
      if (totalEl) totalEl.textContent = '$' + (total / 100).toFixed(2);
      if (subEl) subEl.textContent = count + (count === 1 ? ' item' : ' items') + (lb > 0 ? ' • ' + lb + ' lb of meat' : '');
    }
    items.forEach((it) => {
      if (it.classList.contains('is-locked')) return;
      it.addEventListener('click', () => { it.classList.toggle('is-off'); update(); });
    });
    if (addBtn) addBtn.addEventListener('click', () => {
      const payload = [];
      items.forEach((it) => {
        if (!it.classList.contains('is-off')) payload.push({ id: parseInt(it.dataset.variantId, 10), quantity: 1 });
      });
      if (payload.length) smAddToCart(payload, addBtn);
    });
    update();
  });

  /* ---------- announcement rotator ---------- */
  document.querySelectorAll('[data-sm-announce]').forEach(function (bar) {
    var msgs = bar.querySelectorAll('.sm-announce__msg');
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-on');
    }, 4200);
  });

  /* ---------- header: scroll shadow + burger / mobile menu ---------- */
  document.querySelectorAll('[data-sm-header]').forEach(function (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    }, { passive: true });

    var burger = header.querySelector('[data-sm-burger]');
    var menu = document.querySelector('[data-sm-mobile-menu]');
    if (!burger || !menu) return;
    function closeMenu() {
      menu.classList.remove('is-open');
      burger.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('sm-lock');
    }
    burger.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      if (open) {
        var rect = header.getBoundingClientRect();
        menu.style.top = Math.max(0, rect.bottom) + 'px';
      }
      burger.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('sm-lock', open);
    });
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMenu); });
    /* quick-add inside the menu: close it so the cart drawer takes the stage */
    menu.addEventListener('click', function (e) {
      if (e.target.closest('.sm-add')) closeMenu();
    });
    window.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
  });

  /* ---------- mega menu ---------- */
  (function () {
    var mega = document.querySelector('[data-sm-mega]');
    var trigger = document.querySelector('[data-sm-mega-trigger]');
    var overlay = document.querySelector('[data-sm-mega-overlay]');
    if (!mega || !trigger) return;
    var timer = null, isOpen = false;
    var canHover = window.matchMedia('(hover: hover) and (min-width: 941px)');
    function open() {
      clearTimeout(timer); isOpen = true;
      mega.classList.add('is-open');
      trigger.classList.add('is-on');
      trigger.setAttribute('aria-expanded', 'true');
      if (overlay) overlay.classList.add('is-on');
    }
    function close() {
      clearTimeout(timer); isOpen = false;
      mega.classList.remove('is-open');
      trigger.classList.remove('is-on');
      trigger.setAttribute('aria-expanded', 'false');
      if (overlay) overlay.classList.remove('is-on');
    }
    trigger.addEventListener('click', function () { isOpen ? close() : open(); });
    if (canHover.matches) {
      trigger.addEventListener('mouseenter', function () { clearTimeout(timer); timer = setTimeout(open, 120); });
      trigger.addEventListener('mouseleave', function () { clearTimeout(timer); timer = setTimeout(close, 220); });
      mega.addEventListener('mouseenter', function () { clearTimeout(timer); });
      mega.addEventListener('mouseleave', function () { clearTimeout(timer); timer = setTimeout(close, 220); });
    }
    if (overlay) overlay.addEventListener('click', close);
    mega.addEventListener('click', function (e) {
      if (e.target.closest('a') || e.target.closest('.sm-add')) close();
    });
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) { close(); trigger.focus(); }
    });
    var lastY = window.scrollY;
    window.addEventListener('scroll', function () {
      if (isOpen && Math.abs(window.scrollY - lastY) > 60) close();
      if (!isOpen) lastY = window.scrollY;
    }, { passive: true });
  })();

  /* ---------- FAQ page: search + category filter ---------- */
  document.querySelectorAll('[data-sm-faqpage]').forEach(function (wrap) {
    var search = wrap.querySelector('[data-fq-search]');
    var chips = wrap.querySelectorAll('.sm-fchip[data-g]');
    var items = wrap.querySelectorAll('.sm-acc[data-g]');
    var titles = wrap.querySelectorAll('.sm-fq-gtitle[data-g]');
    var countEl = wrap.querySelector('[data-fq-count]');
    var emptyEl = wrap.querySelector('[data-fq-empty]');
    var clearBtn = wrap.querySelector('[data-fq-clear]');
    var state = { g: 'all', q: '' };
    function apply() {
      var shown = 0;
      items.forEach(function (it) {
        var okG = state.g === 'all' || it.dataset.g === state.g;
        var okQ = !state.q || it.textContent.toLowerCase().indexOf(state.q) > -1;
        var on = okG && okQ;
        it.classList.toggle('is-hide', !on);
        if (on) shown++;
      });
      titles.forEach(function (t) {
        var any = false;
        items.forEach(function (it) {
          if (it.dataset.g === t.dataset.g && !it.classList.contains('is-hide')) any = true;
        });
        t.classList.toggle('is-hide', !any);
      });
      if (countEl) countEl.textContent = shown + ' of ' + items.length + ' questions';
      if (emptyEl) emptyEl.style.display = shown ? 'none' : 'block';
    }
    if (search) search.addEventListener('input', function () { state.q = search.value.trim().toLowerCase(); apply(); });
    chips.forEach(function (c) {
      c.addEventListener('click', function (e) {
        e.preventDefault();
        state.g = c.dataset.g;
        chips.forEach(function (x) { x.classList.toggle('is-active', x === c); });
        apply();
      });
    });
    if (clearBtn) clearBtn.addEventListener('click', function () {
      if (search) search.value = '';
      state.q = ''; state.g = 'all';
      chips.forEach(function (x) { x.classList.toggle('is-active', x.dataset.g === 'all'); });
      apply();
    });
    apply();
  });

  /* ---------- reveal on scroll ---------- */
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    var els = document.querySelectorAll('.sm-card, .sm-tile, .sm-trust__item, .sm-how__step, .sm-review, .sm-promise__card, .sm-tls, .sm-bundle, .sm-colcard');
    if (!els.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); obs.unobserve(en.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
    els.forEach(function (el, i) {
      el.classList.add('sm-reveal');
      el.style.transitionDelay = (i % 4) * 70 + 'ms';
      obs.observe(el);
    });
  })();

  /* ---------- savings calculator ---------- */
  document.querySelectorAll('[data-sm-calc]').forEach((c) => {
    const range = c.querySelector('input[type=range]');
    const lbEl = c.querySelector('[data-calc-lb]');
    const moEl = c.querySelector('[data-calc-mo]');
    const yrEl = c.querySelector('[data-calc-yr]');
    const perSave = parseFloat(c.dataset.shelf) - parseFloat(c.dataset.ours);
    function update() {
      const lb = +range.value;
      if (lbEl) lbEl.textContent = lb + ' lb';
      if (moEl) moEl.textContent = '$' + Math.round(lb * perSave);
      if (yrEl) yrEl.textContent = '$' + Math.round(lb * perSave * 12);
      const p = ((lb - range.min) / (range.max - range.min)) * 100;
      range.style.background = 'linear-gradient(to right, var(--sm-yellow) ' + p + '%, #fff ' + p + '%)';
    }
    range.addEventListener('input', update);
    update();
  });

  /* ── Dinner planner ── */
  document.querySelectorAll('[data-sm-planner]').forEach((box) => {
    const range = box.querySelector('.sm-dplan__range');
    if (!range) return;
    const weight = parseFloat(box.dataset.weight) || 0;
    const portion = parseFloat(box.dataset.portion) || 1;
    const perweekEl = box.querySelector('[data-sm-plan-perweek]');
    const dinnersEl = box.querySelector('[data-sm-plan-dinners]');
    const weeksEl = box.querySelector('[data-sm-plan-weeks]');
    const recEl = box.querySelector('[data-sm-plan-rec]');
    const freqEl = box.querySelector('[data-sm-plan-freq]');
    const update = () => {
      const perWeek = parseInt(range.value, 10) || 3;
      const dinners = Math.max(1, Math.floor(weight / portion));
      const weeksExact = dinners / perWeek;
      const weeks = weeksExact >= 10 ? Math.round(weeksExact) : Math.round(weeksExact * 2) / 2;
      if (perweekEl) perweekEl.textContent = perWeek;
      if (dinnersEl) dinnersEl.textContent = dinners;
      if (weeksEl) weeksEl.textContent = weeks;
      if (recEl && freqEl) {
        const freq = Math.min(6, Math.max(1, Math.round(weeksExact)));
        freqEl.textContent = freq === 1 ? 'weekly' : 'every ' + freq + ' weeks';
        recEl.hidden = false;
      }
    };
    range.addEventListener('input', update);
    update();
  });


  /* free-shipping bar: animate fill from 0 to target on each (re)render */
  const smShipbarAnimate = (scope) => {
    (scope || document).querySelectorAll('[data-sm-shipbar-fill]').forEach((el) => {
      const pct = Math.max(0, Math.min(100, parseFloat(el.dataset.pct) || 0));
      el.style.width = '0%';
      requestAnimationFrame(() => requestAnimationFrame(() => { el.style.width = pct + '%'; }));
    });
  };
  window.__smShipbarAnimate = smShipbarAnimate;
  smShipbarAnimate(document);

})();